module.exports = __webpack_public_path__ + "img/acuvue_logo_short_2.57f810c.svg?v=1764823240413";